import cauHinhLuongDetailV2 from "../views/setting/cau-hinh-luong-v2/cau-hinh-luong-detail-v2";

export default [
  {
    path: "/app/:userDeptRoleId/setting/cauHinhLuong",
    component: () => import("../views/setting/CauHinhLuong/CauHinhLuongIndex"),
    name: "CauHinhLuong"
  },
  {
    path: "/app/:userDeptRoleId/setting/cauHinhLuong/create",
    // component: () => import("../views/setting/CauHinhLuong/DiagramNew"),
    component: cauHinhLuongDetailV2,
    name: "CauHinhLuongCreate"
  },
  {
    path: "/app/:userDeptRoleId/setting/cauHinhLuong/edit/:id",
    component: cauHinhLuongDetailV2,
    name: "CauHinhLuongEdit"
  },
  {
    path: "/app/:userDeptRoleId/setting/quanTriUser",
    component: () => import("../views/setting/quanTriUser/index.vue"),
    name: "quanTriNguoiDung"
  },
  {
    path: "/app/:userDeptRoleId/setting/quanTriUser/detail/:id",
    components: {
      default: () => import("../views/setting/quanTriUser/index.vue"),
      detail: () => import("../views/setting/quanTriUser/detail.vue")
    },
    name: "QuanTriNguoiDungDetail"
  },
  // Quan tri don vi
  {
    path: "/app/:userDeptRoleId/setting/quanTriDonVi",
    component: () => import("../views/setting/quanTriDonVi/index.vue"),
    name: "QuanTriDonVi"
  },
  {
    path: "/app/:userDeptRoleId/setting/QuanTriDonVi/detail/:id",
    components: {
      default: () => import("../views/setting/quanTriDonVi/index.vue"),
      detail: () => import("../views/setting/quanTriDonVi/detail.vue")
    },
    name: "QuanTriDonViDetail"
  },
  // quan ly uy quyen
  {
    path: "/app/:userDeptRoleId/setting/QuanLyUyQuyen",
    components: {
      default: () => import("../views/setting/quanLyUyQuyen/index.vue")
    },
    name: "QuanLyUyQuyen"
  },
  // {
  //   path: "/app/:userDeptRoleId/setting/QuanLyUyQuyen/detail/:id",
  //   components: {
  //     default: () => import("../views/setting/quanLyUyQuyen/task-index.vue"),
  //     detail: () => import("../views/setting/quanLyUyQuyen/detail.vue")
  //   },
  //   name: "QuanLyUyQuyenDetail"
  // },
  // {
  //   path: "/app/:userDeptRoleId/setting/QuanLyUyQuyen/delete/:id",
  //   components: {
  //     default: () => import("../views/setting/quanLyUyQuyen/task-index.vue")
  //     // detail: () => import('../views/setting/quanLyUyQuyen/cancelDialog.vue')
  //   },
  //   name: "QuanLyUyQuyenDelete"
  // },
  //quan ly ngay nghi le
  {
    path: "/app/:userDeptRoleId/setting/thuVienDungChung",
    components: {
      default: () => import("../views/setting/thuVienDungChung/index.vue")
    },
    name: "ThuVienDungChung"
  },
  {
    path: "/app/:userDeptRoleId/setting/QuanLyNgayNghiLe",
    components: {
      default: () => import("../views/setting/quanLyNgayNghiLe/index.vue")
    },
    name: "QuanLyNgayNghiLe"
  },
  // quan tri danh muc
  {
    path: "/app/:userDeptRoleId/setting/QuanLyDanhMuc",
    components: {
      default: () => import("../views/setting/quanLyDanhMuc/index.vue")
    },
    name: "QuanLyDanhMuc"
  },
  // quan tri vai tro
  {
    path: "/app/:userDeptRoleId/setting/quanLyVaiTro",
    components: {
      default: () => import("../views/setting/quanLyVaiTro/index.vue")
    },
    name: "QuanLyVaiTro"
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyVaiTro/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyVaiTro/index.vue"),
      detail: () => import("../views/setting/quanLyVaiTro/detail.vue")
    },
    name: "QuanLyVaiTroDetail"
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyVaiTro/delete/:id",
    components: {
      default: () => import("../views/setting/quanLyVaiTro/index.vue")
    },
    name: "QuanLyVaiTroDelete"
  },
  {
    path: "/app/:userDeptRoleId/profile",
    components: {
      default: () => import("../views/setting/profileManagement/index.vue")
    },
    name: "profileManagement"
  },
  {
    path: "/app/:userDeptRoleId/setting/car",
    components: {
      default: () => import("../views/setting/danhMucXe/index.vue")
    },
    name: "danhMucXe"
  },

  // Quan lý loại tài liệu
  // {
  //   path: "/app/:userDeptRoleId/setting/quanLyLoaiTaiLieu",
  //   component: () => import("../views/setting/quanLyLoaiTaiLieu/index.vue"),
  //   name: "QuanLyLoaiTaiLieu"
  // },
  {
    path: "/app/:userDeptRoleId/setting/quanLyLoaiTaiLieu",
    component: () => import("../views/setting/quanLyLoaiTaiLieuV2/index.vue"),
    name: "QuanLyLoaiTaiLieu"
  },

  //region Quan ly phong hop
  {
    path: "/app/:userDeptRoleId/setting/quanLyPhongHop",
    components: {
      default: () => import("../views/setting/quanLyPhongHop/index.vue")
    },
    name: "QuanLyPhongHop"
  },
  {
    path: "/app/:userDeptRoleId/setting/quanLyPhongHop/detail/:id",
    components: {
      default: () => import("../views/setting/quanLyPhongHop/index.vue")
    },
    name: "QuanLyPhongHopDetail"
  },
  //endregion

  //region Quan ly tai xe
  {
    path: "/app/:userDeptRoleId/setting/quanLyTaiXe",
    components: {
      default: () => import("../views/setting/quanLyTaiXe/index.vue")
    },
    name: "QuanLyTaiXe"
  }
  //endregion
];



// WEBPACK FOOTER //
// ./src/router/setting.js